export enum PosthogFeatureFlags {
    DFU = 'direct-file-upload',
    OPPORTUNITIES_PAGE_ENABLED = 'opportunities-page-enabled',
    OPPORTUNITY_LANDING_PAGE = 'opportunity-landing-page',
    PARTNER_REPAYMENT_DASHBOARD_VIEW = 'partner-repayment-dashboard-view',
    KNOWLEDGE_CENTER_CARD_ENABLED = 'knowledge-center-card-enabled',
    FINANCING_REDIRECT_TO_ESL = 'financing-redirect-to-esl',
    MY_BENEFITS_PAGE_ENABLED = 'my-benefits-page-enabled',
    FUND_2_ENABLED = 'fund-2-enabled',
    SEPARATE_ATTRACT_UPSKILL_FLOWS_ENABLED = 'separate-attract-upskill-flows-enabled',
    KLAVIYO_WIDGET_OPPORTUNITIES='klaviyo-widget-opportunities',
    DASHBOARD_PROFILE_POPUP='show-dashboard-profile-popup',
    ELIGIBILITY_CHECK_FLOW_ENABLED = 'eligibility-check-flow-enabled',
}

export const FeatureFlagVariants = {
  OPPORTUNITY_LANDING_PAGE: {
    SHOW: 'show-landing-page',
    HIDE: 'hide-landing-page',
  },
  ELIGIBILITY_CHECK_FLOW_ENABLED: {
    SHOW: 'show-eligibility-check-flow',
    HIDE: 'hide-eligibility-check-flow',
  },
} as const;
